import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

const generateGuestSessionId = () => `session_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;

interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
    guestSessionId?: string;
    c_code?: string;
    c_company_number?: string;
    c_h_company?: string;
    c_phone?: string;

    setAuth: (data: Partial<AuthState>) => void;
    clearAuth: () => void;
    logout: () => void;
}

const customStorage: PersistStorage<AuthState> = {
    getItem: name => {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
    },
    setItem: (name, value) => {
        localStorage.setItem(name, JSON.stringify(value));
    },
    removeItem: name => {
        localStorage.removeItem(name);
    },
};

export const useAirAuthStore = create(
    persist<AuthState>(
        (set, get) => {
            const existingGuestSessionId = typeof window !== "undefined" && localStorage.getItem("guest_session_id");

            const newGuestSessionId = existingGuestSessionId || generateGuestSessionId();

            if (!existingGuestSessionId && typeof window !== "undefined") {
                localStorage.setItem("guest_session_id", newGuestSessionId);
            }

            return {
                accessToken: null,
                refreshToken: null,
                guestSessionId: newGuestSessionId,

                setAuth: data => set(state => ({ ...state, ...data })),

                clearAuth: () => {
                    customStorage.removeItem("auth-storage");
                    set({
                        accessToken: null,
                        refreshToken: null,
                        guestSessionId: get().guestSessionId,
                        c_code: undefined,
                        c_company_number: undefined,
                        c_h_company: undefined,
                        c_phone: undefined,
                    });
                },

                logout: () =>
                    set(state => ({
                        ...state,
                        accessToken: null,
                        refreshToken: null,
                    })),
            };
        },
        {
            name: "auth-storage",
            storage: customStorage,
        },
    ),
);
